import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getApiV1WeddingsByWeddingIdAuthMeOptions } from '@wedding-tech/api-client/tanstack'

import { FullPageSpinnerPortal } from '@/components/common/Spinner/FullPagePortal'
import { UserDashboardPage } from '@/components/pages/Dashboard/UserDashboardPage'

export const Route = createFileRoute('/e/$eventId/_dashboard/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { eventId } = Route.useParams()
  const { data, isLoading } = useQuery(
    getApiV1WeddingsByWeddingIdAuthMeOptions({ path: { weddingId: eventId } }),
  )

  if (isLoading) {
    return <FullPageSpinnerPortal />
  }

  return <UserDashboardPage />
}
